import { render, staticRenderFns } from "./phieu-luong.vue?vue&type=template&id=9eca08e4"
import script from "./phieu-luong.vue?vue&type=script&lang=js"
export * from "./phieu-luong.vue?vue&type=script&lang=js"
import style0 from "./phieu-luong.vue?vue&type=style&index=0&id=9eca08e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports